// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3olqF","colMin":"styles_colMin__1MuRH","colCheckbox":"styles_colCheckbox__Dtgz0"};